import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { SafeString } from '@ember/template';
import type { WithBoundArgs } from '@glint/template';
import { PrismCard } from '@mylighthouse/prism-ember';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import MarketTotalRevenueKpiItemReference from 'lumen/components/market/total-revenue/kpi-item/reference';

interface MarketTotalRevenueKpiItemSignature {
  Args: {
    subtitle?: string;
    title: string;
    tooltipMessage?: string;
    value: string | SafeString;
  };
  Blocks: {
    default: [
      {
        ReferenceItem: WithBoundArgs<
          typeof MarketTotalRevenueKpiItemReference,
          never
        >;
      },
    ];
  };
}

const MarketTotalRevenueKpiItem = <template>
  <PrismCard>
    <:header as |Header|>
      <div class="flex items-center gap-100">
        <Header.title>
          {{@title}}
        </Header.title>
        {{#if @tooltipMessage}}
          <GeneralIconWithTooltip @tooltipContent={{@tooltipMessage}} />
        {{/if}}
      </div>
    </:header>

    <:content>
      <div class="flex flex-col gap-400">
        <div class="flex flex-row items-center justify-between">
          <span class="heading-1 truncate">
            {{@value}}
          </span>
          <div class="flex flex-col gap-50">
            {{yield (hash ReferenceItem=MarketTotalRevenueKpiItemReference)}}
          </div>
        </div>
        {{#if @subtitle}}
          <span class="text-200--regular">
            {{@subtitle}}
          </span>
        {{/if}}
      </div>
    </:content>
  </PrismCard>
</template> satisfies TOC<MarketTotalRevenueKpiItemSignature>;

export default MarketTotalRevenueKpiItem;
